import { DATES } from 'const/filters'
import { DashboardTab, DateRangeFilter, Widget } from 'types'

import { followsTab } from './rangeLag'

/**
 * A scheduled export's range stands in for each tab's own, as the schedule
 * form promises: "This custom date range will override all tab-level date
 * ranges. Any date ranges set at the widget level will remain." So the tab
 * prints with the scheduled range, and its widgets work their lag out from it.
 */
export function withPrintedRange(
    tab: DashboardTab,
    dateRange: DateRangeFilter | undefined
): DashboardTab {
    if (!dateRange) {
        return tab
    }
    return { ...tab, localFilters: { ...tab.localFilters, [DATES]: dateRange } }
}

/** The scheduled range for a widget that follows its tab; none for one with its own. */
export function printedWidgetRange(
    widget: Widget,
    dateRange: DateRangeFilter | undefined
): DateRangeFilter | undefined {
    return followsTab(widget) ? dateRange : undefined
}
